module.exports = __webpack_public_path__ + "static/media/stock-warehouse.9da55665.svg";